import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-item-categoria',
  templateUrl: './item-categoria.component.html',
  styleUrls: ['./item-categoria.component.scss']
})
export class ItemCategoriaComponent {

  @Input() nombre: string = "";
  @Input() descripcion: string = "";
  @Input() requiereAutenticacion: boolean;

  @Output("evento_click") evento_click: EventEmitter<any> = new EventEmitter<any>();

  ejecutarFuncion() {
    this.evento_click.emit();
  }
}
